import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
  Stack,
  Typography
} from "@mui/material";
import { MoreVert as MoreIcon, Build as BuildIcon } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { FETCH_TRADE_PRODUCTS, SAVE_TRADE_PRODUCTS } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import { BIGrey, BIRed } from "../../assets/helpers";
import SearchField from "../common/SearchField";
import AddProductModal from "../common/AddProductModal";
import { useDispatch } from "react-redux";
import { setShowReport } from "../../redux/actions/actions";
import { English } from "../../constant/EnglishFallback";
import Emptydata from "../common/Emptydata";
import InfiniteScroll from "react-infinite-scroll-component";
import Pages from "../../constant/ReportModel";

function TradeProductSection({ id, scrollId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData, multiLanguageData, reportSuccess } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const ENGLISH = English.Trades || {};
  const LanguageData = multiLanguageData?.Trades || {};
  const {
    BUTTON_ADD_PRODUCT = ENGLISH.BUTTON_ADD_PRODUCT,
    TEXT_TRADE_DETAILS_INFO = ENGLISH.TEXT_TRADE_DETAILS_INFO,
    TEXT_TRADE_DETAILS_INFO_SUBTEXT = ENGLISH.TEXT_TRADE_DETAILS_INFO_SUBTEXT,
    BUTTON_REPORT = ENGLISH.BUTTON_REPORT,
    TEXT_NO_RESULTS_FOUND = ENGLISH.TEXT_NO_RESULTS_FOUND,
    TEXT_SEARCH_THIS_TRADE = ENGLISH.TEXT_SEARCH_THIS_TRADE,
    TEXT_FOR_TRADE_VIEW = ENGLISH.TEXT_FOR_TRADE_VIEW,
    TEXT_ADD_PRODUCT_TO_TRADE = ENGLISH.TEXT_ADD_PRODUCT_TO_TRADE
  } = LanguageData;
  const debounceTimeout = useRef(null);
  const [productData, setProductData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearchLoader, setShowSearchLaoder] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [product, setProduct] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  useEffect(() => {
    if (reportSuccess !== true) getInitialData();
  }, [reportSuccess]);

  const getInitialData = async () => {
    setIsLoading(true);
    await getProductData(searchTerm, 1, "fristTimeApiCall");
    setIsLoading(false);
  };

  const getProductData = async (searchTerm, pageNumber, fristTimeApiCall) => {
    try {
      setAllDataLoaded(true);
      const obj = {
        PageNr: pageNumber,
        NrOfRecPerPage: 20,
        FullSearch: searchTerm ?? "",
        SearchList: [{ TradeId: id }],
        userId: Number(currentUserId),
        SortList: [{}],
        FetchAllowedRecordsOnly: true,
        TypeOfObjectReturned: ""
      };

      // Fetch product data
      const res = await Postrequestcall(FETCH_TRADE_PRODUCTS, obj, loginData?.accessToken);
      if (res.status === 200) {
        // Sort the response data by product name
        let resData =
          res?.data?.data?.sort((a, b) => a?.productName?.localeCompare(b?.productName)) ?? [];

        // Group the data by manufacturerId or manufacturerName
        const groupedData = resData.reduce((acc, item) => {
          const key =
            item?.manufacturerId === 0 || item?.manufacturerName?.trim() === ""
              ? "Unknown Manufacturer"
              : item?.manufacturerName;

          if (!acc[key]) {
            acc[key] = {
              manufacturerId: item?.manufacturerId,
              manufacturerName:
                item?.manufacturerId === 0 || item?.manufacturerName?.trim() === ""
                  ? "Unknown Manufacturer"
                  : item?.manufacturerName,
              items: []
            };
          }

          acc[key].items.push(item);
          return acc;
        }, {});

        // Convert groupedData to an array of groups
        let groupData = Object.values(groupedData);

        // Separate "Unknown Manufacturer" data to be added at the end
        const noRoleData = groupData.find(
          (group) => group?.manufacturerName === "Unknown Manufacturer"
        );

        // If "Unknown Manufacturer" group exists, remove it and add it to the end
        if (noRoleData) {
          groupData = groupData.filter(
            (group) => group?.manufacturerName !== "Unknown Manufacturer"
          );
          groupData.push(noRoleData); // Add "Unknown Manufacturer" group at the end
        }

        // Set product data
        if (pageNumber > 1) {
          setTimeout(() => {
            setProductData((prevProducts) => [...prevProducts, ...groupData]);
          }, 500);
        } else {
          setProductData(() => groupData);
          // Set hasData for the first time API call
          if (fristTimeApiCall) {
            setHasData(groupData?.length > 0);
          }
        }
      }
    } catch (error) {
      console.log("getProductData-> Error While Getting Trade Product Data: ", error);
    } finally {
      setShowSearchLaoder(false);
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      name: Pages?.tradesProducts?.name,
      AppScreenId: Pages?.tradesProducts?.id,
      recordId: product.productId ?? 0
    };
    console.log("reportObj", reportObj);
    dispatch(setShowReport(reportObj));
  };

  const onAddProductClick = () => {
    setShowAddProductModal(true);
  };

  const onItemClick = (item) => {
    navigate(`/product/${item?.productId}`);
  };

  const onProductClick = (currentTarget, product) => {
    setProduct(product);
    setMoreMenuAnchorEl(currentTarget);
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const saveProduct = async (productId) => {
    try {
      setIsLoading(true);
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            ProductId: productId,
            TradeId: id,
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1
          }
        ]
      };
      await Postrequestcall(SAVE_TRADE_PRODUCTS, obj, loginData?.accessToken);
      await getInitialData();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("saveProduct-> Error While Saving Trade Product: ", error);
    }
  };

  const NoInformation = () => {
    return (
      <Stack gap={1} sx={{ height: "100%" }}>
        <Button onClick={onAddProductClick} sx={{ alignSelf: "flex-end" }}>
          {BUTTON_ADD_PRODUCT}
        </Button>
        <Box className="empty-data-card">
          <Emptydata
            icon={<BuildIcon className="emptydata-icon" />}
            firstText={TEXT_TRADE_DETAILS_INFO}
            secondText={TEXT_TRADE_DETAILS_INFO_SUBTEXT}
          />
        </Box>
      </Stack>
    );
  };

  const renderListing = () => {
    return (
      <Box>
        <Stack gap={1}>
          <Typography variant="body1" color="textSecondary">
            {TEXT_FOR_TRADE_VIEW}
          </Typography>
          <SearchField
            placeholder={TEXT_SEARCH_THIS_TRADE}
            value={searchTerm}
            onChange={(value) => {
              setShowSearchLaoder(true);
              const searchValue = value;
              setSearchTerm(searchValue);
              if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
              }
              debounceTimeout.current = setTimeout(() => {
                getProductData(value);
              }, 1000);
            }}
            onSubmit={() => {
              setShowSearchLaoder(true);
              setShowSearchLaoder(searchTerm);
              getProductData(searchTerm);
            }}
            size={"small"}
          />
          <Button variant="text" sx={{ alignSelf: "flex-end" }} onClick={onAddProductClick}>
            {BUTTON_ADD_PRODUCT}
          </Button>
        </Stack>
        <Stack spacing={1}>
          {showSearchLoader ? (
            <Stack style={{ padding: "30px" }}>
              <Loader />
            </Stack>
          ) : productData?.length > 0 ? (
            <>
              <InfiniteScroll
                dataLength={productData?.length}
                next={async () => {
                  increaseOffset((pageNumber) => {
                    getProductData(searchTerm, pageNumber);
                  });
                }}
                hasMore={true}
                loader={
                  !allDataLoaded ? null : (
                    <h4 style={{ display: "flex", justifyContent: "center" }}>
                      <Loader />
                    </h4>
                  )
                }
                scrollableTarget={scrollId}>
                <List disablePadding>
                  {productData.map((item) => (
                    <Box key={item?.manufacturerId ?? item?.id}>
                      <ListSubheader
                        key={`subheader-${item?.manufacturerId}`}
                        sx={{ pl: 0.5, cursor: "pointer" }}
                        onClick={() => {
                          item?.manufacturerId && navigate(`/manufacture/${item?.manufacturerId}`);
                        }}>
                        {item?.manufacturerName}
                      </ListSubheader>
                      <Stack spacing={1}>
                        {item?.items?.map((product) => (
                          <Card
                            key={product?.id ?? `${product?.productName}-${Math.random()}`}
                            className="pagelist-content">
                            <ListItem
                              // key={product?.id}
                              style={{ padding: "0px" }}
                              secondaryAction={
                                <IconButton
                                  onClick={(event) => onProductClick(event.currentTarget, product)}>
                                  <MoreIcon />
                                </IconButton>
                              }>
                              <ListItemButton
                                onClick={() => {
                                  onItemClick(product);
                                }}>
                                <ListItemText primary={product?.productName} />
                              </ListItemButton>
                            </ListItem>
                          </Card>
                        ))}
                      </Stack>
                    </Box>
                  ))}
                </List>
                <Menu
                  anchorEl={moreMenuAnchorEl}
                  open={Boolean(moreMenuAnchorEl)}
                  onClose={() => setMoreMenuAnchorEl(null)}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}>
                  <MenuItem onClick={() => handleOpenReportModal()} style={{ color: BIRed }} dense>
                    {BUTTON_REPORT}
                  </MenuItem>
                </Menu>
              </InfiniteScroll>
            </>
          ) : (
            <Stack
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              style={{ color: BIGrey, padding: "30px" }}>
              {TEXT_NO_RESULTS_FOUND}
            </Stack>
          )}
        </Stack>
      </Box>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? <Loader /> : hasData ? renderListing() : <NoInformation />}
        {showAddProductModal && (
          <AddProductModal
            open={showAddProductModal}
            onClose={() => {
              setShowAddProductModal(false);
            }}
            from={"trade"}
            mainId={id}
            saveProduct={saveProduct}
            title={TEXT_ADD_PRODUCT_TO_TRADE}
          />
        )}
      </Card>
    </Box>
  );
}

export default TradeProductSection;
